import { useReducer, createContext, useContext } from 'react';
import reducer from './connections-reducer';
import { profileData } from '../../data';
import Constants from '../../constants';

const ConnectionsContext = createContext();
const initialState = {};
const ConnectionsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <ConnectionsContext.Provider value={{ ...state }}>
      {children}
    </ConnectionsContext.Provider>
  );
};

const useConnectionsContext = () => {
  return useContext(ConnectionsContext);
};

export { ConnectionsProvider, useConnectionsContext };
